import { render, staticRenderFns } from "./SurveyInit.vue?vue&type=template&id=037b3946&scoped=true&"
import script from "./SurveyInit.vue?vue&type=script&lang=js&"
export * from "./SurveyInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b3946",
  null
  
)

export default component.exports